"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));
var _Radio = _interopRequireDefault(require("./Radio"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function hasCheckAttribute(radioButton) {
  return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked; // eslint-disable-line no-prototype-builtins
}
var RadioGroup = /*#__PURE__*/
function (_Component) {
  _inherits(RadioGroup, _Component);
  function RadioGroup() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, RadioGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadioGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      numberCheckedRadioButtons: 0,
      selected: ''
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event, newSelection) {
      _this.updateRadioButtons(newSelection); // Successful update

      if (_this.state.numberCheckedRadioButtons === 0) {
        if (_this.props.onChange) _this.props.onChange(event, newSelection);
      }
    });
    return _this;
  }
  _createClass(RadioGroup, [{
    key: "getSelectedValue",
    value: function getSelectedValue() {
      return this.state.selected;
    }
  }, {
    key: "setSelectedValue",
    value: function setSelectedValue(newSelectionValue) {
      this.updateRadioButtons(newSelectionValue);
    }
  }, {
    key: "updateRadioButtons",
    value: function updateRadioButtons(newSelection) {
      if (this.state.numberCheckedRadioButtons === 0) {
        this.setState({
          selected: newSelection
        });
      } else {
        console.warn("Cannot select a different radio button while another radio button\n        has the 'checked' property set to true.");
      }
    }
  }, {
    key: "clearValue",
    value: function clearValue() {
      this.setSelectedValue('');
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      // eslint-disable-line camelcase
      var count = 0;
      var selected = '';
      var _this$props = this.props,
        valueSelected = _this$props.valueSelected,
        defaultSelected = _this$props.defaultSelected;
      if (valueSelected !== undefined) {
        selected = valueSelected;
      } else if (defaultSelected !== undefined) {
        selected = defaultSelected;
      }
      _react["default"].Children.forEach(this.props.children, function (option) {
        if (hasCheckAttribute(option)) count++;
      }, this);
      this.setState({
        numberCheckedRadioButtons: count,
        selected: selected
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (nextProps.hasOwnProperty('valueSelected')) {
        // eslint-disable-line no-prototype-builtins
        this.setState({
          selected: nextProps.valueSelected
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        style = _this$props2.style,
        className = _this$props2.className,
        inline = _this$props2.inline;
      var composedStyle = inline ? _objectSpread({}, style, {
        display: 'flex',
        alignItems: 'baseline',
        flexWrap: 'wrap'
      }) : _objectSpread({}, style);
      var options = _react["default"].Children.map(this.props.children, function (option) {
        var _option$props = option.props,
          name = _option$props.name,
          value = _option$props.value,
          label = _option$props.label,
          onCheck = _option$props.onCheck,
          other = _objectWithoutProperties(_option$props, ["name", "value", "label", "onCheck"]);
        return option.type && option.type.name === _Radio["default"].name ? _react["default"].createElement(_Radio["default"], _extends({}, other, {
          ref: option.props.value,
          name: _this2.props.name,
          key: option.props.value,
          value: option.props.value,
          label: option.props.label,
          onCheck: _this2.handleChange,
          checked: option.props.value === _this2.state.selected,
          style: _objectSpread({
            marginRight: '20px'
          }, option.props.style)
        })) : option;
      }, this);
      return _react["default"].createElement("div", {
        style: composedStyle,
        className: className
      }, options);
    }
  }]);
  return RadioGroup;
}(_react.Component);
exports["default"] = RadioGroup;
RadioGroup.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  defaultSelected: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  style: _reactStyleProptype["default"],
  inline: _propTypes["default"].bool,
  valueSelected: _propTypes["default"].any // eslint-disable-line react/forbid-prop-types
};
RadioGroup.defaultProps = {
  className: '',
  inline: false
};